import { ErrorApi, interpretarError } from './errores'

export type ObtenerToken = () => Promise<string | null>

export interface OpcionesPeticion {
  metodo?: 'GET' | 'POST'
  parametros?: Record<string, string | number | undefined | null>
  /**
   * Cuerpo JSON. Lo necesitan `/api/agendamiento/resolver` y `/publicar`, que
   * reciben la lista entera de clientes: no cabe en la query string y ademas no
   * es un filtro. Se deja opcional porque hay POST sin cuerpo, como
   * `/api/clientes/{id}/geocodificar`.
   */
  cuerpo?: unknown
  senal?: AbortSignal
}

function construirUrl(ruta: string, parametros?: OpcionesPeticion['parametros']): string {
  if (!parametros) return ruta
  const consulta = new URLSearchParams()
  for (const [clave, valor] of Object.entries(parametros)) {
    // Se omiten vacios para no enviar `?q=` cuando el buscador esta en blanco:
    // el backend lo trataria como un filtro de cadena vacia.
    if (valor === undefined || valor === null || valor === '') continue
    consulta.set(clave, String(valor))
  }
  const cadena = consulta.toString()
  return cadena ? `${ruta}?${cadena}` : ruta
}

export function crearClienteApi(obtenerToken: ObtenerToken) {
  async function pedir<T>(ruta: string, opciones: OpcionesPeticion = {}): Promise<T> {
    const token = await obtenerToken()
    const cabeceras = new Headers({ Accept: 'application/json' })
    if (token) cabeceras.set('Authorization', `Bearer ${token}`)

    // La cabecera solo se pone cuando hay cuerpo: anunciar un JSON que no se
    // manda haria que algunos servidores intentaran parsear el vacio.
    const lleva = opciones.cuerpo !== undefined
    if (lleva) cabeceras.set('Content-Type', 'application/json')

    const respuesta = await fetch(construirUrl(ruta, opciones.parametros), {
      method: opciones.metodo ?? 'GET',
      headers: cabeceras,
      body: lleva ? JSON.stringify(opciones.cuerpo) : undefined,
      signal: opciones.senal,
    })

    if (!respuesta.ok) throw await interpretarError(respuesta)
    return (await respuesta.json()) as T
  }

  return { pedir }
}

export type ClienteApi = ReturnType<typeof crearClienteApi>
export { ErrorApi }
